<template>
	<div data-tour-scope="notify-list">
		<!--		<v-navigation-drawer fixed v-model="navStateFilter" :clipped="$vuetify.breakpoint.lgAndUp" app right class="mt-0" style="top: 0; height: 100%; max-height: 100%">
			<v-card-title>
				{{ this.$vuetify.lang.t('$vuetify.front.filters') }}
				<v-spacer></v-spacer>
			</v-card-title>
			<v-list dense>
				<v-list-item>
					<v-text-field hide-details="auto" @keyup="searchit" v-model="searchfield" append-icon="search" label="Search"></v-text-field>
				</v-list-item>
				<v-list-item>
					<v-select hide-details="auto" v-model="settings.filters.platform" :items="platform" :menu-props="{ maxHeight: '400' }" multiple dense label="Platform"></v-select>
				</v-list-item>

				<v-list-item>
					<v-select hide-details="auto" v-model="settings.filters.status" :items="status" :menu-props="{ maxHeight: '400' }" multiple dense label="Status"></v-select>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>-->
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.notifiche.notifiche') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>

							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!--<v-btn text :href="linkdownload+'?search='+searchfield+'&categories='+settings.filters.categories+'&selected='+selected" exact >
                                    <v-icon>mdi-arrow-collapse-down</v-icon>
                                </v-btn>-->

								<!-- <v-divider vertical></v-divider>-->
								<!--								<v-btn text @click="toggleDrawerFilter">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>-->
							</v-toolbar-items>
						</v-toolbar>

						<v-col cols="12">
							<v-row data-tour="filters">
								<v-col cols="12" md="4">
									<v-text-field v-model="searchfield" label="Cerca" outlined append-icon="mdi-magnify" dense @click:append="getSearch()" @keyup.enter="getSearch()" hide-details></v-text-field>
								</v-col>
								<v-col cols="12" md="4">
									<v-select v-model="settings.filters.platform" :items="platform" multiple dense label="Platform" outlined hide-details></v-select>
								</v-col>
								<v-col cols="12" md="4">
									<v-select v-model="settings.filters.status" :items="status" multiple dense label="Status" outlined hide-details></v-select>
								</v-col>
							</v-row>
						</v-col>
						<v-card v-if="selectedchecbox.length > 0" elevation="0" outlined>
							<v-tabs dark background-color="primary " show-arrows>
								<v-tabs-slider color="primary "></v-tabs-slider>

								<v-tab>
									{{ selectedchecbox.length }}
									<span v-if="selectedchecbox.length === 1" style="margin-left: 1rem"> selezionato </span>
									<span v-else style="margin-left: 1rem"> selezionati </span>
								</v-tab>
								<v-tab @click="deleteItem(null)"> elimina </v-tab>
							</v-tabs>
						</v-card>

						<v-data-table
							data-tour="table"
							v-model="selectedall"
							:headers="headers"
							:items="getNotifies"
							:options.sync="settings.options"
							:server-items-length="total"
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							show-select
							:mobile="isMobile"
							@input="toggle"
							:mobile-breakpoint="0"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<!--:hide-default-header="isMobile"-->

							<template v-slot:body="{ items }">
								<!-- telefono: ogni notifica diventa una card con il messaggio nel corpo -->
								<tbody v-if="mobileCards" class="notify-cards">
									<tr
										v-for="item in items"
										:key="item._id"
										:data-tour="item.operation === '_SYNC_AMAZON_ITEM_FOUND_ALERT_' ? 'row-amazon' : item.operation === '_SYNC_EBAY_ITEM_FOUND_ALERT_' ? 'row-ebay' : 'row'"
									>
										<td :colspan="headers.length + 1" class="px-3 py-1">
											<key-value-card :fields="campiCard(item)">
												<template v-slot:title>
													<div class="d-flex align-center">
														<img :src="getImageMarketplace(item.provider)" :alt="item.provider" class="notify-logo mr-2" />
														<v-chip x-small outlined :color="tipoNotifica(item.type).color">{{ tipoNotifica(item.type).text }}</v-chip>
													</div>
												</template>
												<template v-slot:actions>
													<v-checkbox class="mt-0 pt-0" data-tour="row-check" v-model="selectedchecbox" :value="item._id" color="primary" hide-details></v-checkbox>
													<v-menu offset-y>
														<template v-slot:activator="{ on }">
															<v-btn icon small elevation="0" :color="item.status || 'grey'" v-on="on" data-tour="tag" title="Etichetta colore">
																<v-icon small>mdi-tag</v-icon>
															</v-btn>
														</template>
														<v-list dense>
															<v-list-item v-for="colore in coloriEtichetta" :key="colore">
																<v-btn @click="changeStatus(item, colore)" elevation="0" icon :color="colore"><v-icon>mdi-tag</v-icon></v-btn>
															</v-list-item>
														</v-list>
													</v-menu>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small color="primary" v-bind="attrs" v-on="on" data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
																<v-list-item-title class="size9">Elimina</v-list-item-title>
															</v-list-item>
															<v-list-item link v-if="item.operation === '_SYNC_AMAZON_ITEM_FOUND_ALERT_'" data-tour="sync-amazon" @click="syncAmazon(item)">
																<v-list-item-title class="size9">Sincronizza Amazon</v-list-item-title>
															</v-list-item>
															<v-list-item link v-if="item.operation === '_SYNC_EBAY_ITEM_FOUND_ALERT_'" data-tour="sync-ebay" @click="syncEbay(item)">
																<v-list-item-title class="size9">Sincronizza Ebay</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<div class="notify-message" v-html="safeHtml(item.title)"></div>
												<v-btn v-if="internalPath(item.url)" small text color="primary" class="mt-1 px-0" :to="internalPath(item.url)">
													<v-icon left small>mdi-arrow-right</v-icon>
													Apri
												</v-btn>
												<v-btn v-else-if="safeUrl(item.url)" data-tour="download" :href="safeUrl(item.url)" target="_blank" rel="noopener noreferrer" small text color="primary" class="mt-1 px-0">
													<v-icon left small>mdi-download</v-icon>
													Scarica
												</v-btn>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="item in items">
										<tr :key="`${item._id}${_.random(1, 10000)}`" :data-tour="item.operation === '_SYNC_AMAZON_ITEM_FOUND_ALERT_' ? 'row-amazon' : item.operation === '_SYNC_EBAY_ITEM_FOUND_ALERT_' ? 'row-ebay' : 'row'">
											<!-- v-bind:class="toggleClass(1)"-->
											<!--<td >  <v-checkbox color="blue" v-model="selected" :value="item" hide-details style="margin-top: 0px;padding-top: 0px;" ></v-checkbox></td>-->
											<td>
											<v-checkbox class="mt-0 mr-0 pr-0" data-tour="row-check" v-model="selectedchecbox" :value="item._id" color="primary" hide-details></v-checkbox>
											</td>
											<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
												<v-menu top eager>
													<template v-slot:activator="{ on, attrs }">
												<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
															<v-icon dark> mdi-dots-vertical </v-icon>
														</v-btn>
													</template>
													<v-list>
												<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
															<v-list-item-title class="size9">Elimina</v-list-item-title>
														</v-list-item>
												<v-list-item link v-if="item.operation === '_SYNC_AMAZON_ITEM_FOUND_ALERT_'" data-tour="sync-amazon" @click="syncAmazon(item)">
															<v-list-item-title class="size9">Sincronizza Amazon</v-list-item-title>
														</v-list-item>
												<v-list-item link v-if="item.operation === '_SYNC_EBAY_ITEM_FOUND_ALERT_'" data-tour="sync-ebay" @click="syncEbay(item)">
															<v-list-item-title class="size9">Sincronizza Ebay</v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
											</td>

											<td>{{ item.created_at | moment('DD/MM/YYYY HH:mm:ss') }}</td>
											<td>
												<v-avatar size="32px" tile>
													<img :src="getImageMarketplace(item.provider)" :alt="item.Platform" />
												</v-avatar>
											</td>
											<td>
												<v-chip v-if="item.type === 'success'" class="ma-2" small color="green" outlined>Success</v-chip>
												<v-chip v-else-if="item.type === 'error'" class="ma-2" small color="error" outlined>Error</v-chip>
												<v-chip v-else-if="item.type === 'warning'" class="ma-2" small color="orange" outlined>Warning</v-chip>
												<v-chip v-else-if="item.type === 'info'" class="ma-2" small color="primary" outlined>Info</v-chip>
											</td>
											<td>
												<span v-html="safeHtml(item.title)"></span>
											<v-btn v-if="internalPath(item.url)" small text color="primary" class="ml-2" :to="internalPath(item.url)">
													<v-icon left small>mdi-arrow-right</v-icon>
													Apri
												</v-btn>
											<v-btn v-else-if="safeUrl(item.url)" data-tour="download" :href="safeUrl(item.url)" target="_blank" rel="noopener noreferrer" small text color="primary" class="ml-2">
													<v-icon left small>mdi-download</v-icon>
													Scarica
												</v-btn>
											</td>
											<td>
											<v-menu
												data-tour="tag"
													:disabled="disabled"
													:absolute="absolute"
													:open-on-hover="openOnHover"
													:close-on-click="closeOnClick"
													:close-on-content-click="closeOnContentClick"
													:offset-x="offsetX"
													:offset-y="offsetY"
												>
													<template v-slot:activator="{ on }">
														<v-btn icon small elevation="0" :color="item.status || 'grey'" v-on="on">
															<v-icon>mdi-tag</v-icon>
														</v-btn>
													</template>
													<v-list dense>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'red')" elevation="0" icon color="red"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'pink')" elevation="0" icon color="pink"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'purple')" elevation="0" icon color="purple"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'indigo')" elevation="0" icon color="indigo"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'blue')" elevation="0" icon color="blue"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'green')" elevation="0" icon color="green"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'yellow')" elevation="0" icon color="yellow"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'orange')" elevation="0" icon color="orange"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
														<v-list-item>
															<v-btn @click="changeStatus(item, 'grey')" elevation="0" icon color="grey"><v-icon>mdi-tag</v-icon></v-btn>
														</v-list-item>
													</v-list>
												</v-menu>
											</td>
										</tr>
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
			<v-dialog :value="getDialog" fullscreen hide-overlay eager transition="dialog-bottom-transition" persistent internal-activator no-click-animation :eager="true" :retain-focus="false">
			</v-dialog>
			<TourOverlay :tour="tour"></TourOverlay>

			<v-dialog v-model="dialogconfirm" max-width="290">
				<v-card>
					<v-card-title class="headline">Sei sicuro?</v-card-title>
					<v-card-text>Eliminando la notifica non potrai più ripristinarla </v-card-text>

					<v-card-actions>
						<v-spacer></v-spacer>

						<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

						<v-btn color="primary" text @click="confirmDelete"> Conferma </v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-main>
	</div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { safeHtml, safeUrl, internalPath } from '@/utils/safeHtml';
import { useTour } from '@/components/core/tour/useTour';
import { createNotifyTourSteps, stopNotifyTour } from './notify-tour';

import { openWithReturn } from '@/components/core/pageReturn';
import { salvaPubblicazione } from '@/components/marketplace/syncHandoff';

export default {
	name: 'Notify',
	setup() {
		return { tour: useTour(createNotifyTourSteps(), { onStop: stopNotifyTour }) };
	},
	data() {
		return {
			menu: false,
			loadingDownload: false,
			errorDownloadReview: '',
			modalDownloadReview: false,
			idStart: '',
			idEnd: '',
			componentKey: 0,
			items: [],
			setinterval: '',

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: {
				search: '',
				filters: {
					status: [],
					platform: [],

					preparation_date: [],
					payments: [],
					agents: [],
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			},

			listSize: [15, 25, 50, 100, 250, 500, 750, 1000],
			linkdownload: '',
			searchfield: '',
			selected: [],
			selectedchecbox: [],
			selectedall: [],
			// filters: {
			//     Status: [],
			//     Platform: [],
			//     created_at: [],
			// },
			/* pagination:{
                     sortBy: 'buyer.name',
                     descending: true,
                     rowsPerPage: 15
                 },*/
			//options: {},
			total: 0,
			expanded: [],
			singleExpand: false,
			headers: [
				{ text: '', value: '' },

				{ text: 'Date', value: 'created_at' },
				{ text: 'Platform', value: 'provider' },
				{ text: 'Type', value: 'type' },
				{ text: 'Title', value: 'title' },
				{ text: 'Azioni', value: '', sortable: false },
			],

			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,
			isMobile: true,
			dialogconfirm: false,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			parseDate: [],
			dataordine: '',
			datapreparazione: '',
			platform: [],
			packagings: [],
			status: ['red', 'pink', 'purple', 'indigo', 'blue', 'green', 'yellow', 'orange', 'grey'],
			payments: [],
			agents: [],
			choosePlaform: [],
			chooseStatus: [],
			choosePayments: [],
			Totale: 0,
			Fee: 0,
			Refund: 0,
			Gain: 0,
			page: 1,

			//Invoice Fattureincloud
			TypeInvoice: '',
			InvoiceItem: '',
			magento: false,
			shopify: false,
			prestashop: false,
			woocommerce: false,
			fattureincloud: false,
			dialogOrderSupplier: false,
			dateOrderSupplier: '',
			checkInPreparazione: true,
			checkRollbackInPreparazione: false,
			operation: '',
		};
	},
	/*created () {
            this.setDialog(false)
            this.initialize();

        },*/
	filters: {
		fixed: function (value) {
			if (!+value) return '';
			//  return  value = value.toFixed(2)
			return _.round(value, 2);
			//return  value
		},
	},
	/* sockets: {
            connect() {
                console.log('socket connected')
            },
            customEmit(val) {
                console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
            }
        },*/

	created() {},
	async mounted() {
		let promises = [];
		promises.push(this.fetchSetting());

		//promises.push(this.fetchService(['ebay', 'magento', 'shopify', 'fattureInCloud']));
		promises.push(this.fetchServiceactive(['fattureInCloud', 'ebay', 'magento', 'shopify', 'mws', 'aliexpress', 'prestashop', 'woocommerce']));

		const result = await Promise.all(promises);
		const status = result[1];

		let magento = status.find(el => el.service === 'magento' && el.active === true);
		if (magento) {
			this.magento = magento.active;
			this.platform.push('Magento');
		}
		let shopify = status.find(el => el.service === 'shopify' && el.active === true);
		if (shopify) {
			this.shopify = shopify.active;
			this.platform.push('Shopify');
		}

		let aliexpress = status.find(el => el.service === 'aliexpress' && el.active === true);
		if (aliexpress) {
			this.aliexpress = aliexpress.active;
			this.platform.push('Aliexpress');
		}

		let prestashop = status.find(el => el.service === 'prestashop' && el.active === true);
		if (prestashop) {
			this.prestashop = prestashop.active;
			this.platform.push('Prestashop');
		}

		let woocommerce = status.find(el => el.service === 'woocommerce' && el.active === true);
		if (woocommerce) {
			this.woocommerce = woocommerce.active;
			this.platform.push('Woocommerce');
		}

		let fattureincloud = status.find(el => el.service === 'fattureInCloud' && el.active === true);
		if (fattureincloud) {
			this.fattureincloud = fattureincloud.active;
		}
		let mws = status.find(el => el.service === 'mws' && el.active === true);
		if (mws) {
			this.platform.push('Amazon');
		}

		let ebay = status.find(el => el.service === 'ebay' && el.active === true);
		if (ebay) {
			this.platform.push('Ebay');
		}

		this.platform.push('Store');
	},
	watch: {
		selectedLength(val) {
			//console.log(val)
			if (val > 0) {
				//_.set(this.selectedall,'[0]',1)
				//_.assign(this.selectedall[0],1)
				this.selectedall = [-1];
			}
		},
		selectedchecbox() {
			if (this.selectedchecbox.length === 1) {
				let el = this.selectedchecbox[0];
				let item = _.find(this.getOrders, i => {
					return i._id === el;
				});
				if (item) {
					if (item.Invoice && item.Invoice.Number) {
						if (item.Invoice.Name === 'Ricevuta') {
							this.TypeInvoice = 'Ricevuta';
						}
						if (item.Invoice.Name === 'Fattura') {
							this.TypeInvoice = 'Fattura';
						}
						this.InvoiceItem = true;
					} else {
						this.InvoiceItem = false;
					}

					if (item.Status === 'In Preparazione') {
						this.checkInPreparazione = false;
						this.checkRollbackInPreparazione = true;
					}
				}
			} else {
				this.checkInPreparazione = true;

				_.forEach(this.selectedchecbox, ord => {
					let item = _.find(this.getOrders, i => {
						return i._id === ord;
					});
					if (item) {
						if (item.Status === 'In Preparazione') {
							this.checkInPreparazione = false;
							this.checkRollbackInPreparazione = true;
						}
					}
				});
			}
		},
		'settings.options': {
			handler(val) {
				if (_.isUndefined(this.settings.options.sortBy[0]) && this.settings.options.sortBy[0] !== '') {
					var outcome = this.getSortDesc;
					outcome = !outcome;
					this.settings.options.sortBy = [];
					this.settings.options.sortDesc = [];
					this.settings.options.sortBy.push(this.getSortBy);
					this.settings.options.sortDesc.push(outcome);
				}
				if (val.page === this.page) {
					this.settings.options.page = 1;
				}
				this.page = val.page;
				/*if(this.setinterval){
                        clearInterval(this.setinterval)
                    }*/
				this.getDataFromApi();
			},

			deep: true,
		},
		'settings.filters': {
			handler: function () {
				this.settings.options.page = 1;
				this.getDataFromApi();
			},
			deep: true,
		},
	},
	components: {
		KeyValueCard,
		TourOverlay,
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		// stessi colori del menu etichetta della tabella desktop
		coloriEtichetta() {
			return ['red', 'pink', 'purple', 'indigo', 'blue', 'green', 'yellow', 'orange', 'grey'];
		},
		selectedLength() {
			return this.selectedchecbox.length;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',

			getDrawerFilter: 'settings/getDrawerFilter',

			getNotifies: 'notify/getItems',
			getSortBy: 'notify/getSortBy',
			getSortDesc: 'notify/getSortDesc',
			getLanguage: 'profile/getLanguage',
			getSettings: 'settings/getSetting',
		}),

		navStateFilter: {
			get: function () {
				return this.getDrawerFilter;
			},
			set: function () {
				return this.getDrawerFilter;
			},
		},
		filteredItems() {
			var filters = this.getOrders;

			filters = filters.filter(d => {
				//console.log("fine",moment(this.parseDate[1]+" 23:59:59").utc().format());
				if (this.parseDate.length === 1) {
					return (
						d.created_at >
						moment(this.parseDate[0] + ' 00:00:00')
							.utc()
							.format()
					);
				}
				if (this.parseDate.length === 2) {
					//console.log("inizio",moment(this.parseDate[0]+" 00:00:00").utc().format());
					//return moment(d.created_at).utc().format()  < moment(this.parseDate[0]+" 00:00:00").utc().format() && moment(d.created_at).utc().format() > moment(this.parseDate[1]+" 23:59:59").utc().format()
					return (
						d.created_at >
							moment(this.parseDate[0] + ' 00:00:00')
								.utc()
								.format() &&
						d.created_at <
							moment(this.parseDate[1] + ' 23:59:59')
								.utc()
								.format()
					);
					//filters.push(d.created_at > moment(this.parseDate[0]+" 00:00:00").utc().format() && d.created_at < moment(this.parseDate[1]+" 23:59:59").utc().format());
				}
				return d;
			});

			filters = filters.filter(d => {
				//console.log(this.choosePlaform)
				if (this.choosePlaform.length > 0) {
					return this.choosePlaform.includes(d.Platform);
					//filters.push(this.choosePlaform.includes(d.Platform))
				}
				return d;
			});
			filters = filters.filter(d => {
				//console.log(this.choosePlaform)
				if (this.chooseStatus.length > 0) {
					return this.chooseStatus.includes(d.Status);
					//filters.push(this.choosePlaform.includes(d.Platform))
				}
				return d;
			});
			filters = filters.filter(d => {
				//console.log(this.choosePlaform)
				if (this.choosePayments.length > 0) {
					return this.choosePayments.includes(d.Checkout.PaymentMethods);
					//filters.push(this.choosePlaform.includes(d.Platform))
				}
				return d;
			});
			//this.Totale=12.4
			let sum;
			if (filters.length > 0) {
				sum = filters.reduce((total, current) => total + current.Total, 0);

				this.Totale = parseFloat(sum, 2).toFixed(2);
			}
			if (filters.length > 0) {
				sum = filters.reduce((total, current) => total + current.Refund, 0);

				this.Refund = parseFloat(sum, 2).toFixed(2);
			}
			//console.log(filters)
			if (filters.length > 0) {
				var total = 0;
				var refund = 0;
				filters.forEach(value => {
					if (value.Buy) {
						total += this.scorporoiva(value.Total, value.BuyVat) - value.Buy - value.Fee - value.Transaction.FeeOrCreditAmount;
					}
					if (value.Refund) {
						//refund += value.Total-value.Buy-value.Fee-value.Transaction.FeeOrCreditAmount
						refund += value.Total - value.Refund - value.Fee - value.Transaction.FeeOrCreditAmount;
					}
				});
				this.Gain = parseFloat(total + refund, 2).toFixed(2);
			}

			return filters;
		},
	},

	methods: {
		// il titolo contiene nomi prodotto dai marketplace: solo grassetto/corsivo/a capo, mai HTML libero
		safeHtml,
		safeUrl,
		internalPath,
		campiCard(item) {
			return [{ label: 'Data', value: item.created_at ? this.$moment(item.created_at).format('DD/MM/YYYY HH:mm:ss') : '' }];
		},
		// stesse etichette e colori dei chip della colonna Type
		tipoNotifica(type) {
			const tipi = {
				success: { text: 'Success', color: 'green' },
				error: { text: 'Error', color: 'error' },
				warning: { text: 'Warning', color: 'orange' },
				info: { text: 'Info', color: 'primary' },
			};
			return tipi[type] || { text: type || '-', color: 'grey' };
		},
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setOrders: 'orders/setOrders',
			setOrder: 'orders/setOrder',
			setIndex: 'orders/setIndex',
			setNotify: 'notify/setItem',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
			setSnackbarApp: 'settings/setSnackbar',
		}),
		...mapActions({
			fetchNotify: 'notify/asyncFetchData',
			deleteItems: 'notify/deleteItems',

			fetchReports: 'orders/asyncFetchReportData',
			destroyData: 'orders/destroyData',
			saveData: 'users/saveData',
			fetchSetting: 'settings/asyncFetchData',
			createSupplierOrders: 'orders/createSupplierOrders',
			fetchStatusOrder: 'statusorders/fetchLists',
			fetchPaymentMethod: 'paymentmethods/fetchLists',
			fetchAgentMethod: 'agents/fetchLists',
			updateEnableAgents: 'orders/updateEnableAgents',
			getOrdersReview: 'orders/getOrdersReview',
			fetchPackagings: 'packagings/getListings',
			getProfile: 'profile/getProfile',
			fetchServiceactive: 'services/getServiceFetchActive',
			//'resetMessages' : 'settings/resetMessages'
		}),
		async propSetMessages(text) {
			this.snackbar.color = 'success';
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
			await this.getDataFromApi();
			this.$forceUpdate();
			this.selectedchecbox = [];
			this.operation = '';
		},

		changeStatus(item, color) {
			let url = 'notifies/update/status';

			this.preload = true;

			//console.log(`${this.getUrl}${url}`);
			axios
				.patch(
					`${this.getUrl}${url}`,
					{
						item: item._id,
						color: color,
					},
					{ headers: { Authorization: `Bearer ${this.getToken}` } },
				)
				.then(() => {
					this.preload = false;
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;

					Object.assign(item, { status: color });
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									//console.log(value.msg);
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.preload = false;
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});

			//console.log(item)
		},
		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
			//this.$store.commit('setDrawer') = !this.$store.state.drawer;
		},
		toggle(event) {
			if (_.size(this.selectedall) === 0) {
				this.selectedchecbox = [];
			} else {
				//console.log(this.selected[0])
				if (event[0] !== -1) {
					this.selectedchecbox = [];
					_.forEach(this.getNotifies, cat => {
						this.selectedchecbox.push(cat._id);
					});
				}
			}
		},
		columnValueList(val) {
			return this.getOrders.map(d => d[val]);
		},

		cleardate() {
			this.parseDate = [];
			this.settings.filters.created_at = [];
			this.settings.filters.preparation_date = [];
		},

		toggleClass(num) {
			if (num === 1) {
				this.active = !this.active;
			}
			if (this.active) {
				return 'active';
			} else {
				return 'notActive';
			}
		},
		resetForm() {
			this.form._id = '';
			this.form.name = '';
			this.form.email = '';
			this.form.password = '';
			this.form.action = '';
		},

		searchit: _.debounce(function () {
			if (_.size(this.searchfield) >= 3) {
				this.settings.search = this.searchfield;
				this.settings.options.page = 1;
			} else {
				this.settings.search = '';
				this.settings.options.page = 1;
			}
		}, 1000),

		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;

				this.settings.filters.enableAgents = false;

				let result = await this.fetchNotify(this.settings);

				this.total = result.total;
				//this.items = result.data.data
				this.setPreload(false);
				this.selectedchecbox = [];
				this.selectedall = [];
			} catch (err) {
				console.log(err);
			}
		},
		async openNew() {
			this.componentKey += 1;

			this.setClearError({});

			this.operation = 'FormCreate';
			this.setMessages();
			this.setDialog(true);
			this.setSnackbar(false);
		},

		checkpresenza(item) {
			return this.selected.includes(item);
		},

		getImagePayment(img) {
			if (!img) {
				return require(`@/assets/images/Other.svg`);
			}

			try {
				return require(`@/assets/images/${img.value}.svg`);
			} catch (e) {
				return require(`@/assets/images/Other.svg`);
			}
		},
		getImageMarketplace(img) {
			var logo = '';
			switch (img) {
				case 'Email':
					logo = require(`@/assets/images/newletter/mail.svg`);
					break;
				case 'Amazon':
					logo = require(`@/assets/images/Amazon.svg`);
					break;
				case 'Feedback':
					logo = require(`@/assets/images/star.svg`);
					break;
				case 'FattureInCloud':
					logo = require(`@/assets/images/fattureincloud_active.svg`);
					break;
				case 'Ebay':
					logo = require(`@/assets/images/Ebay.svg`);
					break;
				case 'Magento':
					logo = require(`@/assets/images/Magento.svg`);
					break;
				case 'Shopify':
					logo = require(`@/assets/images/framework/shopify.svg`);
					break;
				case 'Whatsapp':
					logo = require(`@/assets/images/communication/whatsapp.svg`);
					break;
				case 'Facebook':
					logo = require(`@/assets/images/social/facebook.svg`);
					break;
				case 'Instagram':
					logo = require(`@/assets/images/social/instagram.svg`);
					break;
				// notifiche salvate prima che il provider distinguesse i servizi Meta
				case 'Meta':
					logo = require(`@/assets/images/social/facebook.svg`);
					break;
				case 'gls':
					logo = require(`@/assets/images/corrieri/gls.svg`);
					break;
				case 'Store':
					logo = require(`@/assets/images/store.svg`);
					break;
				// consigli del BO (features/insights)
				case 'Consigli':
					logo = require(`@/assets/images/consigli.svg`);
					break;
				// scansioni di Sito ecommerce > Salute del sito (features/sitehealth)
				case 'Salute del sito':
					logo = require(`@/assets/images/salute-del-sito.svg`);
					break;
				case 'aruba':
					logo = require(`@/assets/images/aruba.svg`);
					break;
				default:
					logo = require(`@/assets/images/flag/map.svg`);
			}
			return logo;
		},
		getImageFlag(img) {
			try {
				return require(`@/assets/images/flag/${img.Country}.svg`);
			} catch (e) {
				return require(`@/assets/images/flag/map.svg`);
			}
		},
		closeSnackbar() {
			this.setSnackbar(false);
		},
		async confirm() {
			let payload = this.form;
			try {
				this.preload = true;
				await this.fetchUsers(payload);
			} catch (err) {
				console.log(err);
			}
			this.preload = false;
		},
		async syncAmazon(key) {
			this.componentKey += 1;
			let item;

			if (!key) {
				let el = this.selected[0];
				item = _.find(this.getItems, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}

			// la maschera di associazione e' una pagina: Indietro (o il salvataggio) torna alle notifiche
			salvaPubblicazione(item);
			openWithReturn(this, { path: '/marketplace/associa/amazon' }, { label: 'Torna alle notifiche' });
		},
		async syncEbay(key) {
			this.componentKey += 1;
			let item;

			if (!key) {
				let el = this.selected[0];
				item = _.find(this.getItems, i => {
					return i._id === el;
				});
			} else {
				item = key;
			}

			// la maschera di associazione e' una pagina: Indietro (o il salvataggio) torna alle notifiche
			salvaPubblicazione(item);
			openWithReturn(this, { path: '/marketplace/associa/ebay' }, { label: 'Torna alle notifiche' });
		},

		deleteItem(item) {
			this.dialogconfirm = true;

			this.form = item;
		},
		async getSearch() {
			if (_.size(this.searchfield) >= 3) {
				this.settings.search = this.searchfield;
				this.settings.options.page = 1;
			} else {
				this.settings.search = '';
				this.settings.options.page = 1;
			}
			this.getDataFromApi();
		},
		confirmDelete() {
			this.dialogconfirm = false;
			//let url = 'notifies/delete';
			this.messages = [];
			var paypload = [];
			if (_.size(this.selectedchecbox) > 0) {
				_.forEach(this.selectedchecbox, cat => {
					paypload.push(cat);
				});
			}
			if (this.form) {
				paypload.push(this.form._id);
			}

			this.deleteItems(paypload)
				.then(() => {
					this.setPreload(false);
					this.getDataFromApi().then(() => {
						this.snackbar.color = 'success';
						this.snackbar.text = 'Operazione effettuata con successo';
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.selected = [];
						this.selectedchecbox = [];
					});
				})
				.catch(error => {
					console.log(error);
				});
			//this.deleteCategories()
		},
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
		//clearInterval(this.setinterval)

		//console.log('Main Vue destroyed')
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.notify-cards,
.notify-cards tr {
	display: block;
	width: 100%;
}
.notify-cards tr,
.notify-cards tr:hover {
	background: transparent !important;
}
.notify-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.notify-cards tr:first-child td {
	padding-top: 12px !important;
}
.notify-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.notify-cards tr + tr td {
	padding-top: 8px !important;
}
.notify-logo {
	width: 24px;
	height: 24px;
	object-fit: contain;
}
.notify-message {
	font-size: 14px;
	word-break: break-word;
}
</style>
